module.exports = __webpack_public_path__ + "static/media/Mp3_Play.52bd3ab3.svg";